// Firebase utilities
export { default as firebaseApp } from "./firebase";
export { getMessagingInstance, registerServiceWorker, onMessageListener } from "./firebase";

// Device detection
export { getDeviceInfo } from "./device";

// Notification context and hooks
export {
  NotificationProvider,
  useNotification,
  clearStoredFCMToken,
} from "./NotificationContext";
